<template>
  <v-app>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :hide-default-footer="true"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Thống kê dữ liệu</v-toolbar-title>
          <v-spacer/>
          <ViewThongKe 
            :showDialog="dialog" 
            :item="item" 
            @cancelled="onCancelled"
          />
        </v-toolbar>
      </template>
      <template v-slot:item.value="{ item }">
        <v-chip
          class="chip-width"
          color="green"
          dark
        >
          {{ item.value | currency }}
        </v-chip>
      </template>
      <template v-slot:body.append>
        <tr v-if="totalNumberOfData > 0">
          <td class="font-weight-bold">Tổng cộng: </td>
          <td class="font-weight-bold">
            <v-chip
              class="chip-width"
              color="orange"
              outlined
              dark
            >
              {{ totalNumberOfData | currency }}
            </v-chip>
          </td>
          <td></td>
        </tr>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          color="primary"
          @click="viewData(item)"
        >
          <v-icon>
            mdi-eye
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import ViewThongKe from '@/views/admin/fake_stats/View';
  import { mapActions } from 'vuex';
  export default {
    components: {
      ViewThongKe
    },
    data: () => ({
      loading: false,
      dialog: false,
      search: '',
      sortDesc: true,
      sortBy: "name",
      headers: [
        { text: 'Dữ liệu', value: 'label' },
        { text: 'Số lượng', value: 'value' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        }
      ],
      items: [],
      totalNumberOfData: 0,
      editedIndex: -1,
      item: {},
      options: {},
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
    },
    watch: {
      dialog (val) {
        val || this.close();
      }
    },
    mounted () {
      this.initialize();
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this;
        app.loading = true;
        axios.get("api/v1/fake-thongke-data")
          .then(response => {
            app.items = response.data;
            response.data.forEach(function(v, i){
              app.totalNumberOfData += v.value;
            });
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onCancelled () {
        this.dialog = false;
      },
      viewData (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      }
    }
  }
</script>
<style>
  .chip-width{
    width: 120px;
    justify-content: center;
  }
</style>